import { gql } from '@apollo/client';

// Every mutation returns the same field set the list renders, so Apollo updates the table from the
// response rather than needing a refetch after each action.
const ITEM_FIELDS = `
  id
  itemType
  slug
  title
  description
  category
  useCase
  dataset
  access
  moduleDependencies
  owner
  source
  refreshedAt
  status
  displayOrder
  currentVersion {
    id
    version
    publishedAt
    content
  }
`;

export const UPSERT_DATA_TOOLS_ITEM = gql`
  mutation UpsertDataToolsItem($input: UpsertDataToolsItemInput!) {
    item: upsertDataToolsItem(input: $input) {
      ${ITEM_FIELDS}
    }
  }
`;

export const PUBLISH_DATA_TOOLS_ITEM_VERSION = gql`
  mutation PublishDataToolsItemVersion($input: PublishDataToolsItemVersionInput!) {
    item: publishDataToolsItemVersion(input: $input) {
      ${ITEM_FIELDS}
    }
  }
`;

export const UNPUBLISH_DATA_TOOLS_ITEM = gql`
  mutation UnpublishDataToolsItem($id: ID!) {
    item: unpublishDataToolsItem(id: $id) {
      ${ITEM_FIELDS}
    }
  }
`;

export const RETIRE_DATA_TOOLS_ITEM = gql`
  mutation RetireDataToolsItem($id: ID!) {
    item: retireDataToolsItem(id: $id) {
      ${ITEM_FIELDS}
    }
  }
`;
